import useSWRMutation from 'swr/mutation'
import { useCallback } from 'react'

import SalesTotal from '../interfaces/SalesTotal.ts'
import { normalizeDate } from '../utils/utils.ts'
import { api } from '../utils/api.ts'

import { useAuth } from './useAuth.tsx'

interface Data {
  since: string
  until: string
}

interface FetchParams extends Data {
  organizationId: string
}

const PATHNAME = 'sales_totals'

const useSalesTotalFetcher = () => {
  const { userData } = useAuth()

  const organizationId = userData?.organization?._id ?? ''

  const fetcher = (url: string, { arg }: { arg: FetchParams }) =>
    api.get<SalesTotal[]>(url, {
      params: {
        organizationId: arg.organizationId,
        // Backend expects these param names (ewww)
        fechaIni: arg.since,
        fechaFin: arg.until,
      },
    })

  const { data, error, isMutating, trigger, reset } = useSWRMutation(PATHNAME, fetcher)

  const fetchSalesTotals = useCallback(
    async ({ since, until }: Data) => {
      if (!since || !until || !organizationId) {
        return undefined
      }

      return await trigger({
        since: normalizeDate(since),
        until: normalizeDate(until),
        organizationId,
      })
    },
    [organizationId, trigger]
  )

  return {
    salesTotals: data?.data ?? [],
    errorSalesTotal: error,
    loading: isMutating,
    fetchSalesTotals,
    reset,
  }
}

export { useSalesTotalFetcher }
